import alertAssign from './alertAssign'

export const alertAssignPromise = alertAssign
